import {
  BowtieWebPath,
  Environment,
  makeAppUrl as makePrAppUrl,
  updateQs,
} from '@bowtie-web/common';
import path from 'path';
import { QuotationContextValue } from '../contexts/QuotationContext';

export const sortAndStringifyQs = (params: object) => {
  return updateQs('', params, {
    encodeValuesOnly: true,
    sort: (a, b) => a.localeCompare(b),
    arrayFormat: 'comma',
  });
};

export const getPlanDetailsUrl = (
  url: string,
  formValues: QuotationContextValue['values'],
) => {
  const [urlWithoutHash, hash = ''] = url.split('#');
  return `${urlWithoutHash}?${sortAndStringifyQs(formValues)}#${hash}`;
};

export const makeAppUrl = (pathname: string, lng: string) => {
  if (import.meta.env.REACT_APP_ENVIRONMENT === Environment.PullRequest) {
    return makePrAppUrl(pathname, lng);
  }
  const base =
    import.meta.env.REACT_APP_ENVIRONMENT === Environment.Production
      ? 'https://app.bowtie.com.hk'
      : import.meta.env.REACT_APP_ENVIRONMENT === Environment.Staging
        ? 'https://app.staging.bowtie.com.hk'
        : 'https://app.dev.bowtie.com.hk';

  return `${base}/#/${path.join(lng, pathname)}`;
};

export const getAppStartPath = (qs: string, locale: string = 'zh') => {
  const appLocale = locale.includes('zh') ? 'zh-hk' : 'en';

  const appStartPath = `${BowtieWebPath.App.Apply}/new?${qs}`;

  return makeAppUrl(appStartPath, appLocale);
};
